import { ICareCategorySetting, IItemService, IService } from "types/admin";
import { IServiceType } from "constant/interfaces";
import { Dayjs } from "dayjs";
import ServiceDeliveryTicket from "./ServiceDeliveryTicket";
import { forwardRef, useEffect, useState } from "react";
import DetailedServiceProvisionStatement from "./DetailedServiceProvisionStatement";

interface IProps {
  createdDate: Dayjs;
  dataPrint: IItemService[] | null;
  setIsReadyPrint: React.Dispatch<React.SetStateAction<boolean>>;
  currentDate?: Dayjs;
  serviceTypes: IServiceType[];
  services: IService[];
  nurseCareLevels: ICareCategorySetting[];
}

const ServiceDeliveryAndDetailedService = (props: IProps, ref: any) => {
  const { dataPrint, nurseCareLevels, ...rest } = props;

  useEffect(() => {
    props.setIsReadyPrint(true);
  }, []);

  return (
    <div className="fixed -top-[10000px]">
      <div ref={ref}>
        {dataPrint?.map((itemService, index) => {
          const { insurance_card } = itemService;

          const care_level = insurance_card?.care_level;
          const nurseCareLevel = care_level
            ? nurseCareLevels.find((item) => item.name === care_level)
            : null;

          const commonProps = {
            ...rest,
            itemService,
            nurseCareLevel,
            index,
            isLastItem: index === dataPrint.length - 1,
          };

          return (
            <div key={itemService.client.id}>
              <div className="print-section">
                <ServiceDeliveryTicket {...commonProps} />
              </div>
              <div className="print-section">
                <DetailedServiceProvisionStatement {...commonProps} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default forwardRef(ServiceDeliveryAndDetailedService);
